import { render, staticRenderFns } from "./BusinessCaseTwo.vue?vue&type=template&id=276bbdac&scoped=true"
import script from "./BusinessCaseTwo.vue?vue&type=script&lang=js"
export * from "./BusinessCaseTwo.vue?vue&type=script&lang=js"
import style0 from "./BusinessCaseTwo.vue?vue&type=style&index=0&id=276bbdac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276bbdac",
  null
  
)

export default component.exports